import React from 'react'
import { useParams, Link as RouterLink } from 'react-router-dom'

import { Box, Link, Stack, Typography } from '@mui/material'
import { useSelectedLanguage } from '../../../../../common/hooks/useSelectedLanguage'
import { useUserType } from '../../../../../common/hooks/useUserType'

import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { PatientHeadlineInfo } from '../../../DoctorPatients/components/PatientHeadlineInfo'
import { DoctorPatientRouteParams } from '../../../DoctorPatients/types/doctorPatients.types'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { TREATMENT_CALENDAR_WIDTH } from '../../../../../config'
import { useTreatmentPanelData } from './TreatmentPanelProvider'

const TreatmentPanelHeader: React.FC = () => {
  const { t } = useTranslation()
  const { patientId } = useParams<DoctorPatientRouteParams>()
  const { treatment } = useTreatmentPanelData()

  const userType = useUserType()
  const selectedLanguage = useSelectedLanguage()

  return (
    <Stack direction="row" px={2}>
      <Box width={TREATMENT_CALENDAR_WIDTH}>
        <PatientHeadlineInfo patient={treatment.patient} />
        <Link
          underline="none"
          component={RouterLink}
          to={`/${userType}/patients/${patientId}`}
          display="flex"
          alignItems="center"
          marginLeft={2}
        >
          <KeyboardArrowLeftIcon fontSize="large" />
          {t('treatment:backToTreatments')}
        </Link>
      </Box>

      <Stack justifyContent="center">
        <Typography variant="h6" component="span">
          {treatment.title[selectedLanguage]}
        </Typography>

        <Typography variant="subtitle1">
          {t('appointment:therapist')}
          {': '}
          {t('common:formattedNameFull', treatment.doctor)}
        </Typography>

        {treatment.pocId && (
          <Box py={0.5}>
            <Typography
              style={{ opacity: 0.8 }}
              variant="body2"
              component="span"
            >
              POC ID: {treatment.pocId}
            </Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  )
}

export { TreatmentPanelHeader }
